export default __webpack_public_path__ + "static/media/children.e1c0f877.png";